import type { ReactNode } from 'react';
import { Form } from 'antd';
import { InputNumber } from '@/components/input/InputNumber';
import { TabelaPrecoExcecaoTipoPreco } from '../types/enum';

export function TabelaPrecoExcecaoFormFieldValor({
    tpe_tipo_preco,
    label,
    className,
}: {
    tpe_tipo_preco: TabelaPrecoExcecaoTipoPreco;
    label?: ReactNode;
    className?: string;
}) {
    if (tpe_tipo_preco === TabelaPrecoExcecaoTipoPreco.PrecoProdutoOuPacoteBarras) {
        return null;
    }

    const isPercentual =
        tpe_tipo_preco === TabelaPrecoExcecaoTipoPreco.PercentualAcrescimo ||
        tpe_tipo_preco === TabelaPrecoExcecaoTipoPreco.PercentualDesconto;

    return (
        <Form.Item
            className={className}
            label={label}
            name='tpe_preco'
            required={true}
            rules={[
                {
                    message: 'Favor informar o valor',
                    required: true,
                },
            ]}
        >
            <InputNumber decimalScale={2} type={isPercentual ? '%' : '$'} />
        </Form.Item>
    );
}
